// extracted by mini-css-extract-plugin
export default {"btnpwd":"ee4efb0e08"};